'use strict'

/**
 * @classdesc お知らせ作成時の絞り込み条件用モーダル内での全選択・解除管理
 */
export default class ToggleAllItemsInCategory {
	/**
	 * @param {jQuery} $e - $('.toggle-all-items-in-category')
	 */
	constructor($e, controller) {
		console.log(`ToggleAllItemsInCategory.constructor`)
		this._$e = $e
		this._controller = controller
		this._isSubCategory = this._$e.data('is-sub-category')
		this._$e.on('click', () => this.onClick())
		this._controller.on('updateToggleAllItemsInCategoryState', () => this.update())
	}

	onClick() {
		console.log(`ToggleAllItemsInCategory.onClick`)

		const rootSelector = this._isSubCategory ? '.sub-category-root' : '.category-root'
		if (this._$e.is(':checked')) {
			this._$e
				.closest(rootSelector)
				.find('.input-checkbtn-input')
				.prop('checked', true)
		} else {
			this._$e
				.closest(rootSelector)
				.find('.input-checkbtn-input')
				.prop('checked', false)
		}

		this._controller.countSelectedCategorizedItems()
		this.update()
	}

	update() {
		console.log(`ToggleAllItemsInCategory.update`)

		if (this._isSubCategory) {
			const $targetCheckbtns = this._$e.closest('.sub-category-root').find('.target-checkbtns-wrapper .input-checkbtn-input')
			const isAllChecked = $targetCheckbtns.length === $targetCheckbtns.filter(':checked').length
			this._$e.prop('checked', isAllChecked)
		}

		const $targetCheckbtns = this._$e.closest('.category-root').find('.target-checkbtns-wrapper .input-checkbtn-input')
		const isAllChecked = $targetCheckbtns.length === $targetCheckbtns.filter(':checked').length
		this._$e.closest('.category-root').find('.toggle-all-items-in-category:not([data-is-sub-category="true"])').prop('checked', isAllChecked)
	}
}
